import { Mountain, Leaf, Coffee } from "lucide-react";
import PhotoFrame from "./PhotoFrame";

const MOMENTS = [
  "Wake up without an itinerary.",
  "Have tea outdoors among the trees.",
  "Ask the caretaker for a comforting home-cooked meal.",
  "Work remotely from a quiet corner.",
  "Let children enjoy the open compound.",
  "Spend evenings talking, reading or doing nothing at all.",
  "Stay long enough to fall into the rhythm of the house.",
];

export default function Experience({ images = [] }) {
  const [a, b, c] = [images[0], images[1], images[2]];
  return (
    <section id="experience" className="py-24 md:py-32 bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28 reveal">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">The ChiMano Experience</div>
            <h2 className="serif text-4xl md:text-5xl lg:text-[58px] leading-[1.02] tracking-tightest text-[#2C392F] font-light">
              Stay the way you would at your own home<span className="italic text-[#985F47]">—only slower.</span>
            </h2>

            <ul className="mt-10 space-y-4">
              {MOMENTS.map((m, i) => (
                <li
                  key={m}
                  data-testid={`experience-moment-${i}`}
                  className="flex gap-4 items-start text-[#1A1C1A]"
                >
                  <span className="mt-2 inline-block h-1.5 w-6 bg-[#985F47] rounded-full flex-shrink-0" />
                  <span className="text-[15px] md:text-base leading-relaxed">{m}</span>
                </li>
              ))}
            </ul>

            <blockquote className="mt-12 border-l-2 border-[#985F47] pl-6 py-3">
              <p className="serif italic text-2xl md:text-3xl text-[#2C392F] leading-snug">
                &ldquo;ChiMano House is not about checking in and checking out. It is about settling in.&rdquo;
              </p>
            </blockquote>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 gap-5">
            <PhotoFrame image={a} placeholderLabel="Tea among the trees" placeholderCaption="Outdoor moments" placeholderIcon={Coffee} ratio="aspect-[3/4]" />
            <PhotoFrame image={b} placeholderLabel="Late afternoon walk" placeholderCaption="Compound pathways" placeholderIcon={Leaf} ratio="aspect-[3/4]" className="mt-12" />
            <PhotoFrame image={c} placeholderLabel="Quiet corner" placeholderCaption="Work from anywhere" placeholderIcon={Mountain} ratio="aspect-[4/5]" className="col-span-2" />
          </div>
        </div>
      </div>
    </section>
  );
}
